var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91406 2.83509H4.46406C3.48397 2.83509 2.99392 2.83509 2.61958 3.02583C2.2903 3.19361 2.02258 3.46133 1.8548 3.79061C1.66406 4.16496 1.66406 4.655 1.66406 5.63509V10.5351C1.66406 11.5152 1.66406 12.0052 1.8548 12.3796C2.02258 12.7089 2.2903 12.9766 2.61958 13.1444C2.99392 13.3351 3.48397 13.3351 4.46406 13.3351H9.36406C10.3442 13.3351 10.8342 13.3351 11.2085 13.1444C11.5378 12.9766 11.8055 12.7089 11.9733 12.3796C12.1641 12.0052 12.1641 11.5152 12.1641 10.5351V8.08509M5.16405 9.83509H6.14086C6.42622 9.83509 6.5689 9.83509 6.70317 9.80286C6.82221 9.77428 6.93601 9.72714 7.04039 9.66317C7.15813 9.59103 7.25902 9.49014 7.4608 9.28836L13.0391 3.71009C13.5223 3.22684 13.5223 2.44334 13.0391 1.96009C12.5558 1.47684 11.7723 1.47684 11.2891 1.96009L5.71078 7.53836C5.509 7.74014 5.40812 7.84103 5.33597 7.95876C5.272 8.06315 5.22486 8.17695 5.19628 8.29599C5.16405 8.43026 5.16405 8.57294 5.16405 8.85829V9.83509Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.04c05a61f20c9a00319e973e50744324.svg";
export { ForwardRef as ReactComponent };